/**
 * V2, living margins (docs/ideas/loom-v2.md, phase 2): the small true things the margin pass wrote beside a turn
 * (overheard, on the wall, elsewhere, a stranger) drift in under it. A note with a follow line on the newest turn
 * carries "Follow", which sends that line as the player's next move. Every theme renders <Margins> after a turn's prose;
 * margins.css has the shared look and each theme's CSS tunes it.
 */
import type { StoryUI } from "../useStory";
import "./margins.css";

export function Margins({ s, n, className = "" }: { s: StoryUI; n: number; className?: string }) {
  const view = s.view;
  const asides = view?.turns.find((t) => t.n === n)?.asides;
  if (!view || !asides?.length) return null;
  // Only the newest reply's notes can be followed (older ones may no longer be within reach).
  const newest = !s.live && view.turns.at(-1)?.n === n;
  return (
    <aside className={`v2-margins ${className}`} aria-label="In the margins">
      {asides.map((a, i) => (
        <div key={`${n}-${i}`} className="v2-note" style={{ "--v2-i": i } as React.CSSProperties}>
          <span className="v2-kind">{a.kind}</span>
          <p>{a.text}</p>
          {a.follow && newest && s.id && (
            <button type="button" className="v2-follow" disabled={s.busy} onClick={() => s.send(a.follow!)} aria-label={`Follow: ${a.follow}`} title={a.follow}>
              Follow
            </button>
          )}
        </div>
      ))}
    </aside>
  );
}
